import { Array, Boolean, Null, Number, Record, Static, String } from 'runtypes';

import { createEnumGuard } from 'src/models/enumGuard';
import { GLOBALIZATION_BUTTON_DIRECTION_VALUES, GLOBALIZATION_VALUES } from 'src/models/globalization/enums';
import { StatusButtonRunType } from 'src/models/status';

const GlobalizationButtonDirectionRunType = createEnumGuard(GLOBALIZATION_BUTTON_DIRECTION_VALUES);

const GlobalizationRunType = createEnumGuard(GLOBALIZATION_VALUES);

const GlobalizationTooltipGlobalizedUserRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	displayname: String,
	initiatingUserAggregateId: String,
	initiatingUserShortcut: String,
	processId: String,
	statusButton: StatusButtonRunType,
});

const GlobalizationTooltipRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	globalizationTooltipGlobalizedUsers: Null.Or(Array(GlobalizationTooltipGlobalizedUserRunType)),
	message: String,
	processId: String,
});

export const GlobalizationWindowAvailableUserRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	avatar: String,
	displayname: String,
	processId: String,
});

export type GlobalizationWindowAvailableUser = Static<typeof GlobalizationWindowAvailableUserRunType>;

export const GlobalizationWindowAvailableGroupRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	displayname: String,
	globalizationWindowAvailableGroupUsers: Array(GlobalizationWindowAvailableUserRunType),
	processId: String,
});

export type GlobalizationWindowAvailableGroup = Static<typeof GlobalizationWindowAvailableGroupRunType>;

export const GlobalizationWindowGlobalizedUserRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	avatar: String,
	displayname: String,
	initiatingUserAggregateId: String,
	initiatingUserAvatar: String,
	initiatingUserDisplayName: String,
	initiatingUserId: Number,
	initiatingUserShortcut: String,
	initiatingUserState: Null.Or(StatusButtonRunType),
	processId: String,
	statusButton: StatusButtonRunType,
});

export type GlobalizationWindowGlobalizedUser = Static<typeof GlobalizationWindowGlobalizedUserRunType>;

export const GlobalizationWindowRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	globalizationWindowAvailableGroups: Null.Or(Array(GlobalizationWindowAvailableGroupRunType)),
	globalizationWindowAvailableUsers: Null.Or(Array(GlobalizationWindowAvailableUserRunType)),
	globalizationWindowGlobalizedUsers: Null.Or(Array(GlobalizationWindowGlobalizedUserRunType)),
	message: String,
	processId: String,
});

export type GlobalizationWindow = Static<typeof GlobalizationWindowRunType>;

export const GlobalizationButtonRunType = Record({
	aggregateId: String,
	aggregateVersion: Number,
	changeable: Boolean,
	direction: GlobalizationButtonDirectionRunType,
	globalization: GlobalizationRunType,
	globalizationTooltip: GlobalizationTooltipRunType,
	globalizationWindow: GlobalizationWindowRunType,
	initiatingUserAggregateId: String,
	initiatingUserAvatar: String,
	initiatingUserShortcut: String,
	initiatingUserState: Null.Or(StatusButtonRunType),
	processId: String,
	render: Boolean,
});

export type GlobalizationButton = Static<typeof GlobalizationButtonRunType>;

export const GlobalizationAndAllAvailableUsersQueryReturnRunType = Record({
	availableGroups: Array(GlobalizationWindowAvailableGroupRunType),
	availableUsers: Array(GlobalizationWindowAvailableUserRunType),
	globalizedUsers: Array(GlobalizationWindowGlobalizedUserRunType),
	message: String,
});

export type GlobalizationAndAllAvailableUsersQueryReturn = Static<
	typeof GlobalizationAndAllAvailableUsersQueryReturnRunType
>;
